<template>
  <div class="bigBox">
    <el-card style="height:80px; width:80%; border: 1px solid #7f7f7f;" :body-style="{padding:0}">
      <div class="card_label" style="height: 28px; width: 100%; text-align: center;padding-top: 5px">股票市场主体风险预警</div>
      <div class="form">
        <el-form :inline="true"  class="demo-form-inline">
          <el-select v-model="stock_code" placeholder="请选择" style="margin-right: 10px;height:10px">
            <el-option
                v-for="item in stockChoose"
                :key="item.value"
                :label="item.stockName"
                :value="item.stock_code"
                size="mini"
            >
            </el-option>
          </el-select>

          <el-form-item >
            开始时间
            <el-date-picker  v-model="start_date" type="date" placeholder="年-月-日" size="mini"></el-date-picker>
          </el-form-item>
          <el-form-item >
            结束时间
            <el-date-picker
                v-model="end_date"
                type="date" placeholder="年-月-日"
                size="mini">
            </el-date-picker>
          </el-form-item>


          <el-form-item>
            <el-button class="grayish_btn" @click="onSubmit3" size="mini" style="margin-right: 20px;">查询</el-button>
          </el-form-item>
        </el-form>

      </div>
    </el-card>

    <div style="display: flex;width: 100%;justify-content: space-around">
      <div class="TopBox">
        <div style="display: flex;width: 90%;justify-content: space-around">
          <div  ref="whole risk" style=" float: left;width: 100%; height: 500px;;"></div>

        </div>
        <div class="bottom-box">
          <div class="warning-component">
            <div class="warning-dates">
              <div class="date-item">前日：<span>{{ prevDayRisk }}</span></div>
              <div class="date-item">昨日：<span>{{ yesterdayRisk }}</span></div>
              <div class="date-item">今日：<span>{{ todayRisk }}</span></div>
              <div class="warning-recent">明日：<span>{{ tomorrowRisk }}</span></div>
              <div class="warning-recent">预测准确率：<span>{{accuracy }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>



  </div>
</template>

<script>
import * as echarts from "echarts";
import http from "@/utils/request";
// import http1 from "@/utils/request2";
import axios from "axios";

export default {
  data(){
    return {

      stock_code:'000001',
      start_date:'2024-06-01',
      end_date:'2025-08-30',
      stockChoose:[{
        stockName:"浦发银行",
        stock_code:'000001',
        value:0
      },{
        stockName:"中国银行",
        stock_code:'000002',
        value:1
      },
        {
          stockName:"中国工商银行",
          stock_code:'000004',
          value:3
        },
        {
          stockName:"中国农业银行",
          stock_code:'000006',
          value:4
        },
        {
          stockName:"中国建设银行",
          stock_code:'000007',
          value:5
        },
        {
          stockName:"交通银行",
          stock_code:'000008',
          value:6
        },
        {
          stockName:"中国邮政储蓄银行",
          stock_code:'000009',
          value:6
        },
      ],
      options_scenario4: [],
      interestRateResults: [], // 利率风险结果
      currencyResults: [], // 汇率风险结果
      stockPriceResults: [
        {
          invest1: 1807,
          invest2: 691019,
          invest3: 9029,
          total: 701855,
          type: "持有股票资产",
          year: 2024,
        },
        {
          "year": 2024,
          "type": "经济资本",
          "invest1": 179.98,
          "invest2": 68825.49,
          "invest3": 899.29,
          "total": 69904.76
        },], // 股票价格风险结果
      formattedDate:'',
      yMax:2,
      yMin:0,
      prevDayRisk:'',
      todayDate:'',
      lastDate:'',
      yesterdayRisk:'',
      todayRisk:'',
      tomorrowRisk:'',
      warningRisk:'',
      riskData:[],
      close_prices:[],
      dates:[],
      accuracy:'',
      today:'',
    }
  },
  props:{
    zoom:{
      type:Array,
      default: function () {
        return []
      }
    }
  },
  watch:{
    zoom(newVal){
      this.datazoom=newVal
    },
    yMax(newVal){
      console.log(newVal)
    }

  },
  mounted() {

    const lastDay =this.getDateAfter30Days()

    this.today =this.getDateDays()
    this.end_date=lastDay
    http.get('/yaliceshi/views_entity_market_risk/', {
      params: {
        stock_code:this.stock_code,
        start_date: '2024-06-01',
        end_date: lastDay,
        model_id: 6,
      }
    }).then(data => {

      this.dates=data.data.dates;

      this.close_prices=data.data.close_prices;

      this.accuracy = data.data.accuracy;

      const length =data.data.close_prices.length
      console.log(length)

      console.log("测试"+data.data.close_prices[length-1])

      this.todayRisk = data.data.close_prices[length-31]

      this.tomorrowRisk = data.data.close_prices[length-30]

      this.yesterdayRisk = data.data.close_prices[length-32]

      this.prevDayRisk = data.data.close_prices[length-33]

      console.log(this.warningRisk)


      this.lastDate=data.data.dates[length-1]

      console.log('预测最后一天的日期'+this.lastDate)

      console.log('后端处理成功:', data.data);

      this.initChart()

    })

  },
  created(){

  },
  methods:{
    //查找指定日期的下标
    findDateIndex(targetDate) {
      // 查找是否存在指定日期
      const exactMatchIndex = this.dates.indexOf(targetDate);
      if (exactMatchIndex !== -1) {
        return exactMatchIndex;  // 如果找到，返回下标
      }

      // 如果没有找到，查找最近的日期
      let closestDate = this.dates[0];
      let closestIndex = 0;
      let minDiff = Math.abs(new Date(this.dates[0]) - new Date(targetDate));

      // 遍历数组找出最近的日期
      for (let i = 1; i < this.dates.length; i++) {
        const diff = Math.abs(new Date(this.dates[i]) - new Date(targetDate));
        if (diff < minDiff) {
          minDiff = diff;
          closestDate = this.dates[i];
          closestIndex = i;
        }
      }
      return closestIndex;  // 返回最近日期的下标
    },

    //查找三十天之后的日期
    getDateAfter30Days() {
      const currentDate = new Date();  // 获取当前日期
      currentDate.setDate(currentDate.getDate() + 30);  // 设置为当前日期加 30 天
      const year = currentDate.getFullYear();  // 获取年份
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');  // 获取月份并补充前导零
      const day = currentDate.getDate().toString().padStart(2, '0');  // 获取日期并补充前导零
      return `${year}-${month}-${day}`;  // 返回格式化后的日期
    },

    //查找三十天之后的日期
    getDateDays() {
      const currentDate = new Date();  // 获取当前日期
      currentDate.setDate(currentDate.getDate());  // 设置为当前日期加 30 天
      const year = currentDate.getFullYear();  // 获取年份
      const month = (currentDate.getMonth()+1).toString().padStart(2, '0');  // 获取月份并补充前导零
      const day = currentDate.getDate().toString().padStart(2, '0');  // 获取日期并补充前导零
      return `${year}-${month}-${day}`;  // 返回格式化后的日期
    },

    arraySpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {  // 年份列
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return 'success-row';
      }
      return '';
    },

    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    onSubmit3() {
      if (!this.stock_code) {
        this.$message.error('请选择正确的银行名称');
        return;
      }else if(!this.start_date||!this.end_date){
        this.$message.error('请选择正确的开始时间和结束时间');
        return;
      }
      const start_date = this.formattedStartDate;
      const end_date = this.formattedEndDate;
      console.log(start_date)
      http.get('/yaliceshi/views_entity_market_risk/', {
        params: {
          stock_code:this.stock_code,
          start_date: start_date,
          end_date: end_date,
          model_id: 6,
        }
      }).then(data => {

        this.updateChart(data.data)
      })
      this.initChart();
    },
    updateChart(data){
      this.dates=data.dates;
      this.close_prices=data.close_prices;
      console.log('后端处理成功11:', data);
      console.log(this.dates[100])
      this.initChart();
    },
    getFormattedDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    initChart(){
      var myChart = echarts.init(this.$refs["whole risk"])
      let option = {
        title: {
          text: '基于内外源协调的主体风险预警',
          left:'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          axisLabel:{
            fontSize:5
          },
          data: this.dates
        },
        yAxis: {
          scale:true,
          splitLine: {
            show: false
          }
        },

        toolbox: {
          right: 120,
          feature: {
            dataView:{
              show:true,
              title: '查看数据',
            },
            restore: {},
            saveAsImage: {}
          }
        },
        //以下是时间轴
        dataZoom: [{
          //也应该是动态的
          startValue: '2024-07-01'
        }, {
          type: 'inside'
        }],

        series: [
          {
            name: '系统性风险指数',
            type: 'line',
            smooth: true,
            // prettier-ignore
            data: this.close_prices,
            markArea: {
              itemStyle: {
                color: 'rgba(255, 173, 177, 0.4)'
              },
              data: [
                [
                  {
                    name: '预测值',
                    xAxis:this.today
                  },
                  {
                    xAxis:this.end_date
                  }
                ],
              ]
            }
          }
        ]
      }
      myChart.setOption(option);
      const that=this
      myChart.on('datazoom', function (params) {
        // Y轴最大值
        this.yMax = myChart.getModel().getComponent('yAxis').axis.scale._extent[1];
        // Y轴最小值
        this.yMin = myChart.getModel().getComponent('yAxis').axis.scale._extent[0];

        // that.$emit("datazoom",[params.start,params.end])

      });

      // myChart.dispatchAction({
      //   type: 'dataZoom',
      //   batch: [{
      //     // 第一个 dataZoom 组件
      //     start: this.datazoom[0],
      //     end: this.datazoom[1]
      //   }]
      // })

    },

  },
  computed: {
    formattedStartDate() {
      return this.formatDate(this.start_date);
    },
    formattedEndDate() {
      return this.formatDate(this.end_date);
    }
  },
}
</script>

<style scoped>
.bigBox{
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.warning-component {
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  text-align: center;
  margin: auto;
}

.warning-dates {
  display: flex;
  justify-content: space-between;
}

.date-item {
  margin: 0 10px;
  font-weight: bold;
}

.warning-recent {
  color: #ff4d4f;
  font-weight: bold;
  margin-bottom: 10px;
}
.form{
  display:flex;
  justify-content:space-between;
  margin-top:5px;
  padding-left:40px;
  height: 60px;
}
.card_label{
  font-size: 13px;
  color:#fff;
  background-color: #7f7f7f;
}
.TopBox{
  display: flex;
  margin-top: 50px;
  flex-direction: column;
  width: 80%;
  justify-content: center;
}
.table{
  width: 80%;
  margin-top: 20px;
}

.demo-form-inline{
  width: 100%;
  display: flex;
  justify-content: left;
}
</style>